import './style/index.less';
import ImportMemberPanel from './ImportMemberPanel';

export default ImportMemberPanel;
